<template>
  <select
    v-model="selectedBuilding"
    @change="setSelectedBuilding($event.target.value)"
    class="c-select c-select--center"
  >
    <option
      :class="{
        'is-active' :selectedBuilding === 'all',
      }"
      value="all"
      class="c-select__option"
    >
      Oversikt
    </option>
    <option
      v-for="building in buildings"
      :key="building.id"
      :value="building.id"
      :class="{
        'is-active' : building.id === selectedBuilding,
      }"
      class="c-select__option"
    >
      {{ building.name }} – {{ building.availability.name }}
    </option>
  </select>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

import Building from '@/models/Building';
import Illustration from '@/models/Illustration';
import Selector from '@/models/Selector';

export default {
  name: 'SelectBuildings',
  data() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    selector() {
      return Selector.query()
        .with('buildings')
        .first();
    },
    buildings() {
      return Building.query()
        .whereId(this.selector.building_ids)
        .with('availability')
        .get();
    },
    selectedBuilding:  {
      get: function() {
        return this.$store.state.entities.buildings.selectedBuilding;
      },
      set: function(newValue) {
        let url;
        let id;
        if (newValue === 'all') {
          id = 'all';
        } else {
          const building = Building.query()
            .whereId(newValue)
            .first();
          url = building.url;
          id = building.id;
        }
        if (url) {
          window.location.href = url;
        } else {
          Building.commit(state => {
            state.selectedBuilding = id;
          });
          Illustration.commit(state => {
            state.currentSection = id;
          });
        }
      },
    },
    activeBuilding() {
      if (this.selectedBuilding !== 'all') {
        return Building.query()
          .whereId(this.selectedBuilding)
          .first();
      } else {
        return 'false';
      }
    },
  },
  watch: {
    selectedBuilding() {
      this.registerEvent(this.selectedBuilding);
    },
  },
  created() {
    EventBus.$on('building-focus', focus => {
      if (focus.hasFocus === true) {
        this.hasFocus = focus.id;
      } else {
        this.hasFocus = false;
      }
    });
  },
  methods: {
    updateSelectedBuilding(selectedBuilding) {
      Building.commit(state => {
        state.selectedBuilding = selectedBuilding;
      });
    },
    setSelectedBuilding(selectedBuilding) {
      localStorage.setItem('selectedBuilding', selectedBuilding);
    },
    toggleBuildingFocus(focus) {
      EventBus.$emit('building-focus', {
        hasFocus: focus.hasFocus,
        id: focus.id,
      });
    },
    registerEvent(event) {
      let building = '';
      if (event === 'all') {
        building = 'alle';
      } else {
        building = this.activeBuilding.name;
      }
      this.$gtag.event(`Vis ${building} (bygg)`, {
        event_category: 'Filter',
        event_label: event,
      });
    },
  },
};
</script>